import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  menuRoot: {
    fontSize: '13px',
    color: theme.palette.headerTitle.main,
  },
  root: {
    width: '50%',
    fontSize: '13px',
  },
  textField: {
    '& .MuiInputBase-input': {
      fontSize: '13px !important',
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px !important',
      color: theme.palette.primary.light,
      fontWeight: 600,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
      fontSize: '18px',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
      {
        paddingBottom: theme.spacing(1.25),
      },
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  buyerFieldContainer: {
    margin: theme.spacing(-0.05, 0, 0, 3),
    width: '50%',
  },
}))
